import {ThemeProvider as MuiThemeProvider} from '@mui/material';
import PropTypes from 'prop-types';
import React from 'react';
import theme from './theme.js';

export const ThemeProvider = ({children}) => (
  <MuiThemeProvider
    theme={theme}
    defaultMode="light"
    modeStorageKey="feeds-mode"
  >
    {children}
  </MuiThemeProvider>
);

ThemeProvider.defaultProps = {
  dark: false,
};

ThemeProvider.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
};
